window.refreshSystemProcedureSpecialism = function() {
    var shouldRefreshProcedureList = false;
    
    $('#dialogProcedureSpecialism').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: {my: "center", at: "center", of: '#contentView'},
        title: window.Resources.ManageSpecialisms,
        open: function (e) {
            $('#procedureSpecialismContainer tbody tr').remove();
            $.ajax({
                url: "/legacy/System/GetProcedureSpecialisms",
                type: "GET",
                dataType: "json",
                success: function (data) {
                    if (data.AllOk) {
                        $.each(data.Items, function (i, data) {
                            var toAppend = '<tr>';
                            toAppend += '<td class="pr20 center"><input type="hidden" class="existingProcedureSpecialismUID" value="' + data.ID + '">' + data.Name + '</td>';
                            toAppend += '<td class="pr5 edit"><span class="edit">edit</span></td>';
                            toAppend += '<td class="pr5 delete">delete</td>';
                            toAppend += '</tr>';

                            $('#procedureSpecialismContainer tbody').append(toAppend);
                        });
                    }
                }
            })
        },
        close: function() {
            if (shouldRefreshProcedureList) {
                openNewAndRemoveActiveFile('/System/Procedures', false);
            }
        }
    });

    $('#dialogProcedureSpecialismAdd').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: {my: "center", at: "center", of: '#contentView'},
        title: window.Resources.Add + " " + window.Resources.Specialism
    });

    $('#dialogProcedureSpecialismEdit').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: {my: "center", at: "center", of: '#contentView'},
        title: window.Resources.Edit + " " + window.Resources.Specialism
    });
    
    $('#btnCloseDialogProcedureSpecialism').on('click', function (e) {
        $('#dialogProcedureSpecialism').dialog('close');
    });

    $('#btnCloseDialogProcedureSpecialismAdd').on('click', function (e) {
        $('#dialogProcedureSpecialismAdd').dialog('close');
    });

    $('#btnCloseDialogProcedureSpecialismEdit').on('click', function (e) {
        $('#dialogProcedureSpecialismEdit').dialog('close');
    });

    $('body').on('click', '.deleteNewProcedureSpecialism, .deleteExistingProcedureSpecialism', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $(this).parent().remove();
    });

    $('#btnAddDialogProcedureSpecialismAdd').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        var allOk = true;
        var errors = "";
        var name = $.trim($('#txtAddPSName').val());
        if (name === "") {
            allOk = false;
            errors += window.ErrorStrings.ErrorEmptyName + '<br />';
        }

        if (!allOk) {
            $('#dialogProcedureSpecialismAdd span.validation').html(errors);
            $('#dialogProcedureSpecialismAdd span.validation').show();
        } else {
            $.ajax({
                traditional: true,
                type: 'POST',
                url: '/legacy/System/AddProcedureSpecialism',
                data: {
                    name: name
                },
                dataType: 'json',
                async: false,
                success:
                    function (data) {
                        if (data.AllOk === true) {
                            var toAppend = '<tr>';
                            toAppend += '<td class="pr20 center"><input type="hidden" class="existingProcedureSpecialismUID" value="' + data.Item.ID + '">' + data.Item.Name + '</td>';
                            toAppend += '<td class="pr5 edit"><span class="edit">edit</span></td>';
                            toAppend += '<td class="pr5 delete">delete</td>';
                            toAppend += '</tr>';

                            $('#procedureSpecialismContainer tbody').append(toAppend);
                            $('#dialogProcedureSpecialismAdd').dialog('close');                            
                        } else if (data.Error === true) {
                            $('#dialogProcedureSpecialismAdd span.validation').text(htmlDecode(data.Message));
                            $('#dialogProcedureSpecialismAdd span.validation').show();
                        }
                    }
            });
        }
    });

    $('#btnSaveDialogProcedureSpecialismEdit').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        var uid = $('#procedureSpecialismEditUID').val();
        var allOk = true;
        var errors = "";
        var name = $.trim($('#txtEditPSName').val());
        if (name == "") {
            allOk = false;
            errors += window.ErrorStrings.ErrorEmptyName + '<br />';
        }

        if (!allOk) {
            $('#dialogProcedureSpecialismEdit span.validation').html(errors);
            $('#dialogProcedureSpecialismEdit span.validation').show();
        } else {
            $.ajax({
                traditional: true,
                type: 'POST',
                url: '/legacy/System/EditProcedureSpecialism',
                data: {
                    id: uid,
                    name: name
                },
                dataType: 'json',
                async: false,
                success:
                    function (data) {
                        if (data.AllOk == true) {
                            var row = $('.existingProcedureSpecialismUID[value=' + uid + ']').parents('tr');
                            row.children('.pr20').text(data.Item.Name);
                            $('#dialogProcedureSpecialismEdit').dialog('close');                            
                        } else if (data.Error == true) {
                            $('#dialogProcedureSpecialismEdit span.validation').text(htmlDecode(data.Message));
                            $('#dialogProcedureSpecialismEdit span.validation').show();
                        }
                    }
            });
        }
    });

    $('#btnAddDialogProcedureSpecialism').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('#txtAddPSName').val("");
        $('#dialogProcedureSpecialismAdd tr.newCombProc').remove();
        $('#dialogProcedureSpecialismAdd span.validation').hide();
        $('#dialogProcedureSpecialismAdd span.validation').text("");
        $('#dialogProcedureSpecialismAdd').dialog('open');
    });

    $('#procedureSpecialismBtn').on('click', function (e) {
        $('#dialogProcedureSpecialism').dialog('open');
    });

    $('#procedureSpecialismContainer tbody').on('click', 'tr td.delete', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        var row = $(this).parent();
        var uid = row.find('.existingProcedureSpecialismUID').val();
        $.ajax({
            url: "/legacy/System/DeleteProcedureSpecialism",
            type: "POST",
            data: {
                id: uid
            },
            dataType: "json",
            success: function (data) {
                if (data.AllOk) {
                    row.remove();
                    shouldRefreshProcedureList = true;                }
            }
        });
    });

    $('#procedureSpecialismContainer tbody').on('click', 'tr td.edit', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        var row = $(this).parent();
        var uid = row.find('.existingProcedureSpecialismUID').val();
        $.ajax({
            url: "/legacy/System/GetProcedureSpecialismById",
            type: "GET",
            data: {
                id: uid
            },
            dataType: "json",
            success: function (data) {
                if (data.AllOk) {
                    $('#txtEditPSName').val(data.Item.Name);
                    $('#dialogProcedureSpecialismEdit tr.existingSpecialism').remove();
                    $('#dialogProcedureSpecialismEdit span.validation').hide();
                    $('#dialogProcedureSpecialismEdit span.validation').text("");
                    $('#procedureSpecialismEditUID').val(uid);
                    $('#dialogProcedureSpecialismEdit').dialog('open');
                }
            }
        });
    });
}